import { createAsyncThunk } from "@reduxjs/toolkit";
import { itemService } from "../../api/services/itemService";

export const fetchItems = createAsyncThunk(
  "items/fetchItems",
  async (_, { rejectWithValue }) => {
    try {
      const data = await itemService.getItems();
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || "Failed to fetch items"
      );
    }
  }
);

